






























import { Component, Vue } from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import * as amplitude from 'amplitude-js';
import { clientsModule } from '@/store';
import { ShoppingShortDTO } from '@/api';
import services from '@/services';

@Component({
  name: 'shoppings-page',
  components: {
    BaseLayout,
  },
})
export default class Catalog extends Vue {
  shoppings: ShoppingShortDTO[] = [];

  comment: string = '';

  date: number | null = null;

  get client() {
    return clientsModule.model;
  }

  async created() {
    if (this.client && this.client.id) {
      const {
        data,
      } = await services
        .shoppingApi()
        .shoppingEndpointGetClientShoppings(this.client.id);
      this.shoppings = data;
      amplitude.getInstance().logEvent('Открыта страница услуг клиента', { clientId: this.client.id });
    }
  }

  // async addShopping() {
  //   if (this.client && this.client.id && this.date) {
  //     try {
  //       const {
  //         data,
  //       } = await services
  //         .shoppingApi()
  //         .shoppingEndpointSaveShopping(
  //           this.client.id,
  //           undefined,
  //           this.comment,
  //           undefined,
  //           this.date,
  //         );
  //       if (data && data.id) {
  //         this.openShopping(data.id);
  //       }
  //     } catch (e) {
  //       // console.error(e);
  //     }
  //   }
  // }

  openShopping(id: number | string) {
    const clientId = String(this.client && this.client.id != null);
    this.$router.push({
      name: 'shopping',
      params: { shoppingId: String(id), clientId },
    });
  }
}
